export default "__VITE_ASSET__BTHfFT0t__"